import { useLanguage } from "@/contexts/LanguageContext";
import { 
  Building2, 
  Shield, 
  BadgeCheck, 
  Clock, 
  Headphones, 
  Zap, 
  Landmark, 
  Wrench 
} from "lucide-react";

const expertiseItems = [
  {
    icon: Building2,
    titleKey: 'expertise.leader.title',
    descKey: 'expertise.leader.description',
    titleDefault: 'Líder na trhu od roku 2013',
    descDefault: '11 rokov skúseností a celkový dohľad kolegov advokátov. Expertíza v každom kroku.',
  },
  {
    icon: Shield,
    titleKey: 'expertise.security.title',
    descKey: 'expertise.security.description',
    titleDefault: 'Bezpečnosť dokumentov',
    descDefault: 'Legalizácia v sídle advokátskej kancelárie s vyššou úrovňou ochrany a mlčanlivosti.',
  },
  {
    icon: BadgeCheck,
    titleKey: 'expertise.zero_complaints.title',
    descKey: 'expertise.zero_complaints.description',
    titleDefault: '0 reklamácií za 11 rokov',
    descDefault: 'Vopred vás informujeme o presnej cene a termíne vybavenia. Žiadne nepríjemné prekvapenia.',
  },
  {
    icon: Clock,
    titleKey: 'expertise.realistic.title',
    descKey: 'expertise.realistic.description',
    titleDefault: 'Realistické termíny, žiadne prázdne sľuby',
    descDefault: 'Vieme presne, koľko ktorý úkon trvá. Nesľubujeme nereálne termíny - dodržíme, čo dohodneme.',
  },
  {
    icon: Headphones,
    titleKey: 'expertise.support.title',
    descKey: 'expertise.support.description',
    titleDefault: 'Podpora aj po vybavení',
    descDefault: 'Pri otázkach zahraničných úradov k vašim dokumentom poskytneme následný support. Komunikujeme v angličtine. Odporúčajú nás slovenské matriky a úrady.',
  },
  {
    icon: Zap,
    titleKey: 'expertise.express.title',
    descKey: 'expertise.express.description',
    titleDefault: 'Expresná rýchlosť bez príplatkov',
    descDefault: 'Všetko riešime expresne ako štandard. Žiadne dodatočné poplatky za rýchle vybavenie.',
  },
  {
    icon: Landmark,
    titleKey: 'expertise.embassies.title',
    descKey: 'expertise.embassies.description',
    titleDefault: 'Priame kontakty na ambasády',
    descDefault: 'Máme naviazané vzťahy s veľvyslanectvami. Presne vieme, ako ktorá ambasáda funguje a čo vyžaduje.',
  },
  {
    icon: Wrench,
    titleKey: 'expertise.fix.title',
    descKey: 'expertise.fix.description',
    titleDefault: 'Vyriešime aj komplikácie',
    descDefault: 'Nesediaci podpisový vzor? Chýbajúce náležitosti? Opravíme a upravíme dokumenty do súladu s požiadavkami konkrétnej krajiny. Máme skúsenosti s desiatkami destinácií.',
  },
];

export function ExpertiseSection() {
  const { t } = useLanguage();

  return (
    <section className="py-16 md:py-24 bg-gradient-to-b from-background to-secondary/20">
      <div className="container mx-auto px-4">
        {/* Header */}
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block px-4 py-1.5 bg-primary/10 text-primary rounded-full text-sm font-medium mb-4">
            {t('expertise.badge', 'Prečo práve my')}
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-4">
            {t('expertise.title', 'Legalizačné centrum')}
          </h2>
          <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
            {t('expertise.subtitle', 'Spolu s advokátskou kanceláriou AKMV prinášame profesionalitu a spokojnosť množstva klientov.')}
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {expertiseItems.map((item, index) => {
            const Icon = item.icon;
            return (
              <div
                key={index}
                className="group relative bg-card rounded-2xl p-6 border border-border hover:border-primary/30 transition-all duration-300 hover:shadow-lg hover:-translate-y-1"
              >
                {/* Icon */}
                <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-primary/20 to-primary/5 flex items-center justify-center mb-4 group-hover:from-primary/30 group-hover:to-primary/10 transition-all duration-300">
                  <Icon className="w-7 h-7 text-primary" />
                </div>
                
                {/* Title */}
                <h3 className="text-lg font-semibold text-foreground mb-2 leading-tight">
                  {t(item.titleKey, item.titleDefault)}
                </h3>
                
                {/* Description */}
                <p className="text-sm text-muted-foreground leading-relaxed">
                  {t(item.descKey, item.descDefault)}
                </p>

                {/* Decorative gradient on hover */}
                <div className="absolute inset-0 rounded-2xl bg-gradient-to-br from-primary/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none" />
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
